import {
  BI_CALCULATIONS_SUMMARY_GET_CALCULATIONS_SUMMARY_INIT,
  BI_CALCULATIONS_SUMMARY_GET_CALCULATIONS_SUMMARY_SUCCESS,
  BI_CALCULATIONS_SUMMARY_GET_CALCULATIONS_SUMMARY_FAILURE,
  BI_CALCULATIONS_SUMMARY_RESET
} from './types';
import Constants from '../../../definitions/constants';
import ActionsTooling from '../../../tooling/actionsTooling';

export function reset() {
  return {
    type: BI_CALCULATIONS_SUMMARY_RESET
  };
}

export function getCalculationsSummary() {
  return async (dispatch) => {
    dispatch(ActionsTooling.defaultInitActionFunction(BI_CALCULATIONS_SUMMARY_GET_CALCULATIONS_SUMMARY_INIT));
    try {
      const resp = await ActionsTooling.defaultExpressApiCall(
        "/api/calculation/getlastperiodscalculationssummary",
        "GET"
      );
      dispatch(ActionsTooling.defaultSuccessActionFunction(BI_CALCULATIONS_SUMMARY_GET_CALCULATIONS_SUMMARY_SUCCESS, resp));
    } catch (error) {
      dispatch(ActionsTooling.defaultErrorActionFunction(BI_CALCULATIONS_SUMMARY_GET_CALCULATIONS_SUMMARY_FAILURE, error));
    }  
  };
}



// WEBPACK FOOTER //
// ./source/client/actions/biCalculationsSummary/index.js